import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import MasterPlanState from "@/modules/master-plan";
import LessonPlanTemplateState from "@/modules/lesson-plan-template";
import { AppBreadCrumbModule } from "@/modules/bread-crumb";
import { Paths } from "@/util/paths";
import { fmtMsg } from "commonui";
import { BreadCrumbMenuLocale } from "@/locales/localeid";
import { MethodologyTypeEnum } from "@/util/enum";

export const MasterPlanLessonPlanEditorResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const masterPlanModule = getModule(MasterPlanState);
	const lessonPlanTemplateModule = getModule(LessonPlanTemplateState);
	const actions: Promise<void>[] = [];
	const { versionGroupId, lessonPlanVersionId, unitId, lessonPlanId, methodology } = to.params;
	actions.push(masterPlanModule.getSignature());
	actions.push(
		masterPlanModule.fetchLessonPlan({
			versionGroupId,
			lessonPlanVersionId,
			unitId: parseInt(unitId, 10),
			lessonPlanId
		})
	);
	actions.push(lessonPlanTemplateModule.fetchLessonPlanTemplates());
	await Promise.all(actions);

	const appBreadCrumbModule = AppBreadCrumbModule;
	const appRoutes = [
		{
			path: Paths.LessonPlanVersion,
			breadcrumbName: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuLPV),
			params: {},
			queryParams: {}
		}
	];

	if (versionGroupId && lessonPlanVersionId && unitId && methodology) {
		appRoutes.push({
			path: Paths.LessonPlanListWithParams,
			breadcrumbName: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuLPList),
			params: {
				versionGroupId,
				lessonPlanVersionId,
				methodology: parseInt(methodology, 10)
			},
			queryParams: {
				unitId: parseInt(unitId, 10)
			}
		});
		appRoutes.push({
			path: Paths.MasterPlan,
			breadcrumbName: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuMasterPlan),
			params: {
				versionGroupId,
				lessonPlanVersionId,
				unitId: parseInt(unitId, 10),
				methodology: parseInt(methodology, 10)
			},
			queryParams: {}
		});
		appRoutes.push({
			path: Paths.MasterPlanLessonPlanEditor,
			breadcrumbName:
				masterPlanModule.currentMethodology === MethodologyTypeEnum.REP
					? fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuPlaylistEditor)
					: fmtMsg(BreadCrumbMenuLocale.BreadCrumbMenuLPEditor),
			params: {
				versionGroupId,
				lessonPlanVersionId,
				unitId: parseInt(unitId, 10),
				methodology: parseInt(methodology, 10),
				lessonPlanId
			},
			queryParams: {}
		});
	}

	appBreadCrumbModule.setBreadCrumbRoutes(appRoutes);
	next();
};
